import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import metaConfig from "./metaConfig";
export function HelmetWrapper() {
  const { pathname } = useLocation();
  const meta = metaConfig[pathname] || metaConfig["/"];

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>
    </>
  );
}